import { useMutation, useQueryClient } from '@tanstack/react-query';
import Swal from 'sweetalert2';

import useForm from '../../../../lib/hooks/useForm';
import { editFollowUp } from './data';

const useEditFollowUp = ({ followUp }) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(editFollowUp, {
    onSuccess: () => {
      queryClient.invalidateQueries(['followUps']);
      Swal.close();
    },
    onError: () => {
      Swal.close();
    },
  });

  const initialValues = {
    subject: followUp.subject,
    sendOn: followUp.sendOn,
  };

  const onSubmit = values => {
    mutate({ followUp: values, followUpId: followUp.id });
  };

  return useForm({
    initialValues,
    onSubmit,
  });
};

export default useEditFollowUp;
